import { Fade, IconButton } from "@mui/material";
import CustomerJsonInfo from "./CustomerInfoIndicator";
import { MoreVert } from "@mui/icons-material";
import { atomWithStorage } from "jotai/utils";
import {
  VisitCustomerContextPageLink,
  VisitCustomerGDrivePageLink,
  VisitCustomerGKEWorkloadsPageLink,
  VisitCustomerSlackReportsPageLink,
} from "./CustomerTilesInternalTools";
import { VisitCustomerPortalLink } from "./VisitCustomerPortalLink";
import { VisitCustomerMidgardAdminLink } from "./VisitCustomerMidgardAdminLink";
import { VisitCustomerGraphQLLinksDropdown } from "./VisitCustomerGraphQLLinksDropdown";
import { InspectCustomerConfigsDropdown } from "./InspectConfigsDropdown";
import styled from "styled-components/macro";
import AskrConfigInfo from "./AskrConfigIndicator";
import { useAtom } from "jotai";

export const customerTileConfigAtom = atomWithStorage(
  "CustomerTiles:customerTileConfig",
  {
    showMoreInfo: false,
    dimDisabledCustomers: false,
    showAskrConfigs: true,
    showGroupsAndProcesses: true,
  }
);

export function CustomerTileMoreInfo({
  ckey,
  hovered,
  setHovered,
  clicked,
  setClicked,
}: {
  ckey: string;
  hovered: boolean;
  setHovered: (hovered: boolean) => void;
  clicked: boolean;
  setClicked: (clicked: boolean) => void;
}) {
  const visible = clicked || hovered;
  const [{ showAskrConfigs, showGroupsAndProcesses }] = useAtom(
    customerTileConfigAtom
  );
  return (
    <>
      {showGroupsAndProcesses ? <CustomerJsonInfo {...{ ckey }} /> : null}
      {showAskrConfigs ? <AskrConfigInfo {...{ ckey }} /> : null}
      <MoreInfoButtonsStyles>
        <Fade in={visible} unmountOnExit={false} timeout={300}>
          <div className="buttons">
            <VisitCustomerContextPageLink {...{ ckey }} /> {/* HubSpot */}
            <VisitCustomerGDrivePageLink {...{ ckey }} />{" "}
            <VisitCustomerSlackReportsPageLink {...{ ckey }} />{" "}
            <div className="spacer"></div>
            <VisitCustomerGKEWorkloadsPageLink {...{ ckey }} /> {/* GKE */}
            <VisitCustomerGraphQLLinksDropdown {...{ ckey }} />
            {/* Google Drive - Customer Folder */}
            <div className="spacer"></div>
            <VisitCustomerPortalLink {...{ ckey }} /> {/* Portal */}
            <VisitCustomerMidgardAdminLink {...{ ckey }} />
            <div className="spacer"></div>
            <InspectCustomerConfigsDropdown {...{ ckey }} />
          </div>
        </Fade>
        <IconButton
          size="small"
          className="more-info-button"
          style={{
            transform: `translateY(${visible ? 2 : 2}px) rotate(${
              visible ? 90 : 0
            }deg)`,
            transition: "transform 0.2s ease-in-out",
          }}
          onClick={e => {
            e.stopPropagation();
            const nextClicked = !visible;
            setClicked(nextClicked);
            if (!nextClicked) {
              setHovered(false);
            }
          }}
        >
          <MoreVert />
        </IconButton>
      </MoreInfoButtonsStyles>
    </>
  );
}
const MoreInfoButtonsStyles = styled.div`
  position: absolute;
  top: 4px;
  left: auto;
  right: 4px;
  display: flex;
  justify-content: flex-end;
  max-height: 20px;
  overflow: visible;
  .spacer {
    width: 8px;
  }
  .buttons {
    padding: 2px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    display: flex;
    gap: 2px;
  }
  button,
  svg {
    width: 16px;
    height: 16px;
    padding: 2px;
  }
`;
